import React, { Component } from "react";
import { Segment, Progress, Grid, Button, Header, Popup } from "semantic-ui-react";

class CheckboxCard extends Component{
    constructor(props) {
        super(props);
        this.state = {
            Text:props.Text,
            Note:props.Note,
            Count: props.Count,
            Counter:0
        };
    }

    inc = () => this.setState({
        Counter: parseInt(this.state.Counter) === parseInt(this.state.Count) ? this.state.Counter : this.state.Counter + 1
    });

    reset = () => this.setState({
        Counter: 0
    });

  render(){
    return(
        <Segment raised secondary>
            <Grid textAlign="center">
                <Grid.Row onClick={this.inc}>
                    <Grid.Column>
                        <Header size="medium" content={this.state.Text} subheader={`Repeat/Click ${this.state.Count} Times!`} />
                    </Grid.Column>
                </Grid.Row>
                {
                    this.state.Note != null ?
                    <Grid.Row>
                        <Grid.Column>
                            <Popup size='tiny' content={this.state.Note} trigger={<Button circular compact primary size='tiny' content="Tip" />} flowing basic/>
                        </Grid.Column>
                    </Grid.Row>
                    :
                    null
                }
                <Grid.Row>
                    <Grid.Column>
                        <Progress onClick={this.inc} indicating size='medium' progress='value' value={this.state.Counter} total={this.state.Count} />
                        <Button basic compact content="Reset Counter" onClick={this.reset} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>       
        </Segment>
    )
  }
}

export default CheckboxCard;